import { render, staticRenderFns } from "./xietong.vue?vue&type=template&id=39cb0243&scoped=true"
import script from "./xietong.vue?vue&type=script&lang=js"
export * from "./xietong.vue?vue&type=script&lang=js"
import style0 from "./xietong.vue?vue&type=style&index=0&id=39cb0243&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cb0243",
  null
  
)

export default component.exports